import React from 'react';

const AllRights = () => {
  return document.title !== 'Tectu' ? (
    <span className="Rights">© 2024 Wisevoice AI. All Rights Reserved.</span>
  ) : null;
};

export default AllRights;
